<template>
  <div class="p-postEditor__itemWrapper">
    <div v-show="editingItemIndex !== index" @click="editItem">
      <ListItemPreview :item="item" />
    </div>
    <item-form v-if="editingItemIndex === index" :item="item">
      <div class="px-5 p-postEditor__listForm">
        <v-select
          :value="editingItemable.style"
          :items="items"
          class="body-2"
          item-text="style"
          style="width: 300px"
          item-value="value"
          dense
          single-line
          @change="updateEditingItemable($event, 'style')"
        />
        <v-text-field
          :value="editingItemable.title"
          :rules="[presenceValidation]"
          label="リストタイトル"
          style="width: 400px"
          required
          autofocus
          @input="(value) => updateEditingItemable(value, 'title')"
        />
        <component
          :is="editingItemable.style == 'ordered' ? 'ol' : 'ul'"
          class="pa-1"
        >
          <draggable
            v-model="editingItemable.items"
            handle=".p-handle"
            :animation="200"
            :scroll-sensitivity="150"
            :scroll-speed="30"
          >
            <template v-for="(item, index) in editingItemable.items">
              <div :key="index" style='display: flex;'>
                <v-icon class="p-handle" size="25">mdi-menu</v-icon>
                <li class="p-list-item">
                  <v-text-field
                    :value="item"
                    class="body-2"
                    :append-icon="
                      editingItemable.items.length == 1 ? null : 'mdi-delete'
                    "
                    :rules="[presenceValidation]"
                    required
                    dense
                    @click:append="deleteListItem(index)"
                    @input="(value) => updateListItem(value, index)"
                    @keydown.enter="isComposing($event, index+1)"
                    :ref="'listItemInput' + index"
                  />
                </li>
              </div>
            </template>
          </draggable>
        </component>
        <v-btn
          class="ma-1"
          rounded
          small
          depressed
          color="primary"
          @click="addListItem(editingItemable.items.length)"
        >
          <v-icon left> mdi-plus </v-icon>
          追加
        </v-btn>
      </div>
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import ListItemPreview from './previews/ListItemPreview'
import draggable from 'vuedraggable'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'ListItem',
  components: { ListItemPreview, draggable },
  mixins: [itemUtilsMixin, formValidationUtils],
  data: () => {
    return {
      items: [
        { style: '順序ありリスト', value: 'ordered' },
        { style: '順序なしリスト', value: 'un_ordered' }
      ]
    }
  },
  computed: {
    listTag: function () {
      return function (val) {
        if (val === 'unordered') {
          return 'ul'
        } else {
          return 'ol'
        }
      }
    }
  },
  methods: {
    isComposing (event, place) {
      if (event.isComposing) {
        return
      }
      this.addListItem(place)
    },
    addListItem (place) {
      let itemable = {
        ...this.editingItemable,
        items: [...this.editingItemable.items]
      }
      itemable.items.splice(place, 0, '')
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
      let refsName = 'listItemInput' + place
      this.$nextTick(() => this.$refs[refsName][0].focus())
    },
    updateListItem: function (val, index) {
      let itemable = {
        ...this.editingItemable,
        items: [...this.editingItemable.items]
      }
      itemable.items[index] = val
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
    },
    deleteListItem (index) {
      let itemable = {
        ...this.editingItemable,
        items: [...this.editingItemable.items]
      }
      itemable.items.splice(index, 1)
      this.$store.commit('PostEditor/UPDATE_EDITING_ITEMABLE', itemable)
    }
  }
}
</script>

<style scoped>
.p-handle {
  height: 40px;
  padding-right: 10px;
}
.p-list-item {
  background-color: white;
  width: 100%;
}
</style>
